import { Credentials } from "../models/Credentials";
const API_BASE_URL = process.env.REACT_APP_AUDIT_API_URL;

const Login = async (credentials: Credentials) => {
  const response = await fetch(`${API_BASE_URL}/Login/Authenticate`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(credentials),
  });

  return response;
};

const LoginService = {
  Login,
};

export default LoginService;
